import { Ref } from 'vue'

import { useSearchHandler } from '~/api/service/general.service'
import { TRIGGER_WORD } from '~/constants/easter-egg.constants'
import { explorerRoutes } from '~/routes'
import { searchFilterType } from '~/types/search-filter.type'

export const useGeneralSearch = (inputModel: Ref<string>) => {
  const isEnable = computed(() => inputModel.value !== TRIGGER_WORD && inputModel.value.length >= 5)

  const { data, isFetching } = useSearchHandler(inputModel, searchFilterType.ALL, isEnable)

  const resultMap = computed(() => {
    if (!data.value) {
      return new Map<string, Record<string, any>>()
    }
    return data.value.resultMap
  })
  const moveToOnlyResult = () => {
    if (!data.value || !data.value.resultMap.size) {
      return
    }

    if (resultMap.value.get(searchFilterType.BLOCK)?.length === 1) {
      window.open(explorerRoutes.getBlockDetailPage(resultMap.value.get(searchFilterType.BLOCK)?.[0]), '_blank')
      return
    }
    if (resultMap.value.get(searchFilterType.TRANSACTION)?.length === 1) {
      window.open(explorerRoutes.getTransactionDetailPage(resultMap.value.get(searchFilterType.TRANSACTION)?.[0].version), '_blank')
      return
    }
    if (resultMap.value.get(searchFilterType.ADDRESS)?.length === 1) {
      window.open(explorerRoutes.getAccountDetailPage(resultMap.value.get(searchFilterType.ADDRESS)?.[0]), '_blank')
      return
    }
    if (resultMap.value.get(searchFilterType.MODULE)?.length === 1) {
      window.open(explorerRoutes.getModulePage(resultMap.value.get(searchFilterType.MODULE)?.[0].address, resultMap.value.get(searchFilterType.MODULE)?.[0].moduleName), '_blank')
    }
  }

  return { resultMap, isFetching, moveToOnlyResult }
}